export const rowProperties: CSSFunction = () => ({
  width: '100px',
  padding: '6px 8px',

  '&:last-of-type': {
    '& > td': {
      borderBottom: 'none',
    },
  },
});

export const strikesTableHeader: CSSFunction = () => ({
  position: 'sticky',
  top: 0,
  zIndex: 4,
});
